import Axios from 'axios';
import {FaEye, FaCalculator} from 'react-icons/fa';
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'

export const PDetail = ({ match, ...props }) => {
    const { id } = match.params;
    const [data, setData] = useState({
        info: {
            title: '',
            note:''
        }
    });
    const noteRef=useRef(undefined);

    const loadData = async () => {
        const res = await Axios.get(`/api/pinfo/detail/${id}`)
        setData(res.data);
        noteRef.current.innerHTML=res.data.info.note;
    }
    useEffect(() => {
        loadData();
    }, [id])

    const buildHitAndDate=()=>{
        return (
            <div className='more-info'>
                   <span>
                       
                   <FaEye size={12} color='gray'/>
                       {data.info.hits}
                   </span>
                <span>
                        <FaCalculator size={12}/>
                    {moment(data.addDate).format('YYYY-MM-DD')}
                   </span>

            </div>
        )
    };
    return (
        <div>
            <div className='detail-wrap'>

                <h1>
                    {data.info.title}
                </h1>
                {buildHitAndDate()}
                <div ref={noteRef} className='mt-2'></div>
            </div>
        </div>
    )
}
